import "../styles/HeaderHomeOut.css";
import { Loading } from "../../../../assets/icons/Icons";
import condicionesGenerales from "../../../../assets/docs/Condiciones Generales.pdf"
import SidebarActivarCuenta from "../../../../components/sidebar/SidebarActivarCuenta";
import { useEffect, useState } from "react";

const HeadHomeOut = ({
  infoApi,
  setMostrarLogin,
  setShowModalActivaSuccess,
  setObjUsuarioLogin,
  setLoading,
}) => {
  const downloadCondicionesGenerales = async () => {
    setDownloading(true)
    const response = await fetch(condicionesGenerales, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/pdf',
      },
    }).then((response) => {
      return response.blob()
    }).then(blob => {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = `${'Condiciones Generales.pdf'}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setDownloading(false)
    });
  };

  const [mostrarModalActivarCuenta, setMostrarModalActivarCuenta] = useState(false);
  const [urlApi, setUrlApi] = useState("");
  const [codRecaptcha, setCodRecaptcha] = useState("");
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    if (infoApi?.length < 1 || infoApi === undefined) return;
    infoApi?.forEach((element) => {
      setUrlApi(element.urlApi);
      setCodRecaptcha(element.cod_recaptcha);
    });
  }, [infoApi]);

  return (
    <>
      <SidebarActivarCuenta
        urlApi={urlApi}
        codRecaptcha={codRecaptcha}
        show={mostrarModalActivarCuenta}
        setShow={setMostrarModalActivarCuenta}
        setShowLogin={setMostrarLogin}
        setShowModalActivaSuccess={setShowModalActivaSuccess}
        setObjUsuarioLogin={setObjUsuarioLogin}
        setLoading={setLoading}
      />
      <div className="container-fluid banner pe-0 ps-0 d-block d-lg-none">
        {/* <div className="container-xxl pe-0 ps-0"> */}
        <div className="row me-0">
          <div className="col-12 col-md-6 pt-lg-4 pe-0">
            <div style={{ backgroundColor: "#84D9C6" }}>
              <img
                src="/assets/img/homeout/img-banner-homeoutheader.webp"
                className="banner__image d-block d-md-none"
                alt=""
              />
            </div>
            <div className="banner__text__center">
              <h5 className="banner__title">
                <b>¡Hola!</b>
              </h5>
              <p className="banner__text pe-2 mt-3 pb-3">
              Conozcamos juntos todo lo <br/> 
              relacionado con tu <b className="bold">Seguro CPA <br/> 
              Plus Seminuevos,</b> el seguro <br/>
              complementario que te protegerá <br/> 
              contra eventos de <b className="bold">pérdida total o robo total</b>  
              </p>
              <button
                className="banner__button"
                onClick={downloadCondicionesGenerales}
              >
                {downloading ? <Loading/> : "DESCARGAR CONDICIONES GENERALES"}
              </button>
            </div>

            <div className="banner__footer align-items-center d-flex d-md-none">
              <div className="cps-5 banner__footer__text pe-3">
                <p>
                  Llama sin costo: {" "}
                  <span>
                    <b>
                      <a
                        href="tel:8008012400"
                        style={{ fontFamily: "var(--fuente-bold)", textDecoration: "none", color: "black" }}
                      >
                        800 801 2400
                      </a>
                    </b>
                  </span>
                </p>
                <p>
                  Horarios: Lun a vie de 08:00 a 21:00 hrs y <br/>
                  sábados de 09:00 a 18:00 hrs.{" "}
                </p>
                <p>
                  <b>
                    <a
                      href="mailto:sac_mx@cardif.com.mx"
                      style={{ fontFamily: "var(--fuente-bold)", textDecoration: "none", color: "black"}}
                    >
                      sac_mx@cardif.com.mx
                    </a>
                  </b>
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6 d-none d-md-block pe-lg-0">
            <img
              src="/assets/img/homeout/img-banner-homeoutheader.webp"
              className="banner__image"
              alt=""
            />
          </div>
        </div>

        <div
          className="row banner__footer d-none d-md-flex ms-0 me-0"
          style={{ backgroundColor: "#F7F7F7", color: "#000000" }}
        >
          <div className="col-12" style={{color: "var(--principal)", fontSize: "1.2rem"}}>
            <div className="row align-items-center justify-content-center">
              <div
                className="col-3 ps-5 banner__footer__text"
              >
                <p className="">
                  Llama sin costo: {" "}
                  <span className="ps-3 pe-3">
                    <b>
                      <a
                        href="tel:8008012400"
                        style={{ fontFamily: "var(--fuente-bold)", textDecoration: "none", color: "var(--principal)" }}
                      >
                        800 801 2400
                      </a>
                    </b>
                  </span>
                </p>
              </div>
              <div className="col-5 text-center">
                <p className="pe-3">
                  Horarios de atención: Lunes a domingo de 08:00 a 20:00 hrs.
                </p>
              </div>
              <div className="col-3 text-center">
                <p>
                  <a
                    href="mailto:sac_mx@cardif.com.mx"
                    style={{ fontFamily: "var(--fuente-bold)", color: "var(--principal)", textDecoration: "none" }}
                  >
                    sac_mx@cardif.com.mx
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
      </div>
      <div className="home p-0 d-none d-lg-block">
        <div className="container-cookie bannerInicial">
          <div className="row bannerI">
            <div className="col-12 col-md-6 col-back">
              <div className="home__text-container">
                <div className="home__title mb-5">
                  <h2>¡Bienvenido!</h2>
                </div>

                <div className="home__text mb-0">
                  <p className="mb-0" style={{ lineHeight: "1.2" }}>
                  Conozcamos juntos todo lo relacionado con tu <br/> 
                  <b className="bold">Seguro CPA Plus Seminuevos,</b> el seguro <br/> 
                  complementario que te protegerá contra eventos <br/>
                  de <b className="bold">pérdida total o robo total</b>  
                  </p>
                </div>
                <button
                  className="btn__azul"
                  style={{ width: "330px", padding: "1rem 2rem" }}
                  onClick={downloadCondicionesGenerales}
                >
                  {downloading ? <Loading/> : "DESCARGAR CONDICIONES GENERALES"}
                </button>
              </div>
            </div>

            <div className="col-12 col-md-6 col-image p-0">
              <div className="home__image-container">
                <img
                  src="/assets/img/homeout/img-banner-homeoutheader.webp"
                  className="home__image_desks"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="head__footer d-none d-lg-grid">
        <p>
          {" "}
          Llama sin costo:
          <span style={{ fontFamily: "var(--fuente-bold)" }}>
            <b> 800 801 2400</b>
          </span>
        </p>
        <div className="separacion"></div>
        <p>Horarios: Lunes a viernes de 08:00 a 21:00 hrs y sábados de 09:00 a 18:00 hrs.</p>
        <div className="separacion"></div>
        <p>
          <b>
            <a
              href="mailto:sac_mx@cardif.com.mx"
              style={{ fontFamily: "var(--fuente-bold)", color: "var(--principal)", textDecoration: "none" }}
            >
              sac_mx@cardif.com.mx
            </a>
          </b>
        </p>
      </div>
    </>
  );
};

export default HeadHomeOut;
